export default __webpack_public_path__ + "static/assets/afeb2801c7076e47b5394c0024c19f1e.png";